import { TransformedEntry } from '@/services/dashboard/dashboard.types';

type SocialMediaData = {
  platform: string;
  score: number;
};

type BarPosition = 'single' | 'first' | 'last' | 'middle';

export const DEFAULT_WEEKDAY_LABELS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;

const WEEKDAY_TRANSLATION_KEYS = DEFAULT_WEEKDAY_LABELS.map((day) => `dashboard.chart.label.${day}`);

export const getWeekdayLabels = (translate?: (key: string) => string): string[] => {
  if (!translate) return [...DEFAULT_WEEKDAY_LABELS];

  return WEEKDAY_TRANSLATION_KEYS.map((key, index) => translate(key) || DEFAULT_WEEKDAY_LABELS[index]);
};

export const getMondayBasedWeekdayIndex = (date: Date): number => (date.getDay() + 6) % 7;

export const generateRadarData = (data: SocialMediaData[]): SocialMediaData[] =>
  data.map((d) => ({
    platform: d.platform,
    score: d.score,
    maxScore: 100,
  }));

export const getBarPosition = (seriesIndex: number, totalSeries: number): BarPosition => {
  const conditions = {
    isSingle: totalSeries === 1,
    isFirst: seriesIndex === 0,
    isLast: seriesIndex === totalSeries - 1,
  };

  if (conditions.isSingle) return 'single';
  if (conditions.isFirst) return 'first';
  if (conditions.isLast) return 'last';
  return 'middle';
};
export const getBarRadiusByPosition: Record<BarPosition, number | [number, number, number, number]> = {
  single: 2,
  first: [0, 0, 2, 2],
  last: [2, 2, 0, 0],
  middle: 0,
};

export const generateStackedChartData = <K extends string>(
  days: string[],
  categories: { key: K; values: number[] }[],
): TransformedEntry<K>[] => {
  return days.map((day, index) => {
    const entry = { day } as TransformedEntry<K>;
    categories.forEach((cat) => {
      entry[cat.key] = cat.values[index] as TransformedEntry<K>[K];
    });
    return entry;
  });
};
